import { render, staticRenderFns } from "./AcoesInterno.vue?vue&type=template&id=3460ee21&scoped=true&"
import script from "./AcoesInterno.vue?vue&type=script&lang=js&"
export * from "./AcoesInterno.vue?vue&type=script&lang=js&"
import style0 from "./AcoesInterno.vue?vue&type=style&index=0&id=3460ee21&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3460ee21",
  null
  
)

export default component.exports